<template>
  <div class="emergency-step-wrapper" v-if="application">
    <ValidationObserver v-slot="{ handleSubmit, invalid, dirty }" ref="emergencyForm">
      <form class="uk-form" @submit.prevent="handleSubmit(submit)" autocomplete="chrome-off">
        <div class="uk-grid">
          <div class="uk-width-1-1 uk-margin-bottom">
            <h2><strong>Emergency Contact Form</strong></h2>
          </div>
          <div class="uk-width-1-1 uk-margin-bottom">
            <fieldset class="uk-margin-top" v-if="student">
              <legend class="uk-margin-bottom">Youth Participant Contact Information</legend>
              <div class="uk-grid">
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="student.first_name" :name="__('tenant.first_name')"
                    :label="__('tenant.first_name')" :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="student.last_name" :name="__('tenant.last_name')" :label="__('tenant.last_name')"
                    :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="applicant.property_address.line_1" :name="__('global.street_address')"
                    :label="__('global.street_address')" :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="applicant.property_address.line_2" :name="__('global.street_address_line2')"
                    :label="__('global.street_address_line2')" :disabled="true" />
                </div>
                <div class="uk-width-medium-1-3 uk-margin-bottom">
                  <TextInput v-model="applicant.property_address.city" :name="__('global.city')" :label="__('global.city')"
                    :disabled="true" />
                </div>
                <div class="uk-width-medium-1-3 uk-margin-bottom">
                  <TextInput v-model="applicant.property_address.state" :name="__('global.state')" :label="__('global.state')"
                    :disabled="true" />
                </div>
                <div class="uk-width-medium-1-3 uk-margin-bottom">
                  <TextInput v-model="applicant.property_address.zip" :name="__('global.zip')" :label="__('global.zip')"
                    :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('tenant.primary_phone')" v-model="student.primaryPhone"
                    :label="__('tenant.primary_phone')" :disabled="true" />
                </div>
                <div class="uk-width-small-1-2 uk-margin-bottom">
                  <date-picker :name="__('tenant.birth_date')" :label="__('tenant.birth_date')"
                    v-model="student.birth_date" :config="datePickerConfig" :disabled="true" />
                </div>
              </div>
            </fieldset>
            <fieldset class="uk-margin-top" v-if="applicant">
              <legend class="uk-margin-bottom">Parent/Guardian - Emergency Contact Information</legend>
              <div class="uk-grid">
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="applicant.first_name" :name="__('tenant.first_name')"
                    :label="__('tenant.first_name')" :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="applicant.last_name" :name="__('tenant.last_name')"
                    :label="__('tenant.last_name')" :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="application.user.email" :name="__('global.email')" :label="__('global.email')"
                    :disabled="true" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom"></div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone_number1')" v-model="applicant.primaryPhone"
                    :label="__('global.phone_number1')" :disabled="true" />
                  <div class="uk-flex uk-flex-row uk-margin-top">
                    <label class="uk-margin-right">{{ __('global.ok_to_text') }}</label>
                    <toggle-button :color="programSettings['primary-program-color']"
                      v-model="applicant.primaryPhoneEnabled" class="toggle" />
                  </div>
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone_number2')" v-model="applicant.phone2"
                    :label="__('global.phone_number2')" :disabled="true" />
                  <div class="uk-flex uk-flex-row uk-margin-top">
                    <label class="uk-margin-right">{{ __('global.ok_to_text') }}</label>
                    <toggle-button :color="programSettings['primary-program-color']" v-model="applicant.phone2_enabled"
                      class="toggle" />
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="uk-margin-top" v-for="(contact, index) in additionalContacts" :key="index">
              <legend class="uk-margin-bottom">
                <div class="uk-flex uk-width-1-1 contact-legend">
                  <span>Additional Emergency Contact {{ (index + 1) }}</span>
                  <button type="button" class="uk-button uk-button-danger" @click="deleteContact(index)">
                    <i class="a-trash"></i>
                  </button>
                </div>
              </legend>
              <div class="uk-grid">
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="contact.first_name" :name="__('tenant.first_name')"
                    :placeholder="__('tenant.first_name')" rules="required" :label="__('tenant.first_name')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="contact.last_name" :name="__('tenant.last_name')"
                    :placeholder="__('tenant.last_name')" rules="required" :label="__('tenant.last_name')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput type="email" v-model="contact.email" :name="__('global.email')"
                    :placeholder="__('global.email')" rules="required" :label="__('global.email')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom"></div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone_number1')" v-model="contact.phone1"
                    :label="__('global.phone_number1')" rules="required" />
                  <div class="uk-flex uk-flex-row uk-margin-top">
                    <label class="uk-margin-right">{{ __('global.ok_to_text') }}</label>
                    <toggle-button :color="programSettings['primary-program-color']" v-model="contact.phone1_enabled"
                      class="toggle" />
                  </div>
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone_number2')" v-model="contact.phone2"
                    :label="__('global.phone_number2')" />
                  <div class="uk-flex uk-flex-row uk-margin-top">
                    <label class="uk-margin-right">{{ __('global.ok_to_text') }}</label>
                    <toggle-button :color="programSettings['primary-program-color']" v-model="contact.phone2_enabled"
                      class="toggle" />
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="uk-margin-top">
              <button type="button" class="uk-button uk-button-primary" @click="addNewContact">
                <i class="a-circle-plus"></i>
                Add Another Emergency Contact
              </button>
            </div>

            <fieldset v-if="application.jobs_data" class="uk-margin-top">
              <legend class="uk-margin-bottom">Medical Information</legend>
              <div class="uk-grid">
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <label>Does the youth have any food, environment or medication allergies?</label>
                  <div class="uk-margin-top">
                    <validated-section :errors="errors" field="has_allergy">
                      <label class="uk-display-inline"><input type="radio" name="has_allergy" value="1"
                          v-model="application.jobs_data.has_allergy"> Yes</label>
                      <label class="uk-display-inline uk-margin-left"><input type="radio" name="has_allergy" value="0"
                          v-model="application.jobs_data.has_allergy"> No</label>
                    </validated-section>
                  </div>
                  <div class="uk-margin-top" v-if="(application.jobs_data.has_allergy == 1)">
                    <CustomTextarea :rows="2" name="Allergies" v-model="application.jobs_data.allergies"
                      rules="required" />
                  </div>
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <label>Does the youth have an EPI Pen for allergic reactions?</label>
                  <div class="uk-margin-top">
                    <validated-section :errors="errors" field="medical_epi">
                      <label class="uk-display-inline"><input type="radio" name="medical_epi" value="1"
                          v-model="application.jobs_data.medical_epi"> Yes</label>
                      <label class="uk-display-inline uk-margin-left"><input type="radio" name="medical_epi" value="0"
                          v-model="application.jobs_data.medical_epi"> No</label>
                    </validated-section>
                  </div>
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <label>Does the youth have a medical condition? (This includes physical, mental, emotional and behavioral)</label>
                  <div class="uk-margin-top">
                    <validated-section :errors="errors" field="medical_condition">
                      <label class="uk-display-inline"><input type="radio" name="medical_condition" value="1"
                          v-model="application.jobs_data.medical_condition"> Yes</label>
                      <label class="uk-display-inline uk-margin-left"><input type="radio" name="medical_condition"
                          value="0" v-model="application.jobs_data.medical_condition"> No</label>
                    </validated-section>
                  </div>
                  <div class="uk-margin-top" v-if="(application.jobs_data.medical_condition == 1)">
                    <CustomTextarea :rows="3" name="medicalCondition"
                      v-model="application.jobs_data.medical_condition_desc" rules="required" />
                  </div>
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <label>Is the youth on any medications?</label>
                  <div class="uk-margin-top">
                    <validated-section :errors="errors" field="on_medication">
                      <label class="uk-display-inline"><input type="radio" name="on_medication" value="1"
                          v-model="application.jobs_data.on_medication"> Yes</label>
                      <label class="uk-display-inline uk-margin-left"><input type="radio" name="on_medication" value="0"
                          v-model="application.jobs_data.on_medication"> No</label>
                    </validated-section>
                  </div>
                  <div class="uk-margin-top" v-if="(application.jobs_data.on_medication == 1)">
                    <CustomTextarea :rows="3" name="medication" v-model="application.jobs_data.on_medication_desc"
                      rules="required" />
                  </div>
                </div>
              </div>
              <div class="uk-grid">
                <div class="uk-width-medium-1-1 uk-margin-large-bottom">
                  <p><i>***Please note that the CUL WRT University training & internship program does not administer
                      medication. If your youth has a medical need, please speak with a staff member to discuss a plan
                      for
                      ensuring that your child is cared for.</i></p>
                </div>
                <div class="uk-width-medium-1-3 uk-margin-bottom">
                  <TextInput v-model="application.jobs_data.health_insurance_provider"
                    :name="__('tenant.health_insurance_provider')" :placeholder="__('tenant.health_insurance_provider')"
                    :label="__('tenant.health_insurance_provider')" />
                </div>
                <div class="uk-width-medium-1-3 uk-margin-bottom">
                  <TextInput type="text" v-model="application.jobs_data.health_insurance_provider_policy_no"
                    :name="__('tenant.policy_no')" :placeholder="__('tenant.policy_no')"
                    :label="__('tenant.policy_no')" />
                </div>
                <div class="uk-width-medium-1-3 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone')"
                    v-model="application.jobs_data.health_insurance_provider_phone" :label="__('global.phone')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="application.jobs_data.preferred_hospital" :name="__('tenant.preferred_hospital')"
                    :placeholder="__('tenant.preferred_hospital')" rules="required"
                    :label="__('tenant.preferred_hospital')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone')"
                    v-model="application.jobs_data.preferred_hospital_phone" :label="__('global.phone')"
                    rules="required" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="application.jobs_data.youth_doctor" :name="__('tenant.youth_doctor')"
                             :placeholder="__('tenant.youth_doctor')" rules="required" :label="__('tenant.youth_doctor')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone')" v-model="application.jobs_data.youth_doctor_phone"
                                      :label="__('global.phone')" rules="required" />
                </div>

                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <TextInput v-model="application.jobs_data.youth_dentist" :name="__('tenant.youth_doctor')"
                             :placeholder="__('tenant.youth_dentist')" rules="required" :label="__('tenant.youth_dentist')" />
                </div>
                <div class="uk-width-medium-1-2 uk-margin-bottom">
                  <phone-number-input :name="__('global.phone')" v-model="application.jobs_data.youth_dentist_phone"
                                      :label="__('global.phone')" rules="required" />
                </div>
              </div>
            </fieldset>
            <div class="uk-width-1-1 uk-margin-top">
              <p class="uk-margin-bottom">
                  I confirm the above information is correct.
              </p>
            </div>
          </div>
          <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2 uk-margin-top">
            <validated-section :field="'signature_' + applicant.id" :errors="errors">
              <signature-box @updated="onSignatureUpdated" :user-key="applicant.id"
                :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
                :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                :name="applicant.first_name + ' ' + applicant.last_name"
                :color="programSettings['primary-program-color']"></signature-box>
            </validated-section>
          </div>
        </div>

        <p style="color: red;" id="footer-error"></p>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
// import moment from 'moment'
import SignatureBox from "./../../../../../../../components/AppWizard/SignatureBox";
import ValidatedSection from "./../../../../../../../components/Common/ValidatedSection";

export default {
  name: "EmergencyStep",
  props: {
    print: {
      type: Boolean,
      default: false,
    }
  },
  components: { ValidatedSection, SignatureBox },
  data() {
    return {
      errors: {},
      datePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
      },
      additionalContacts: [],
      loading: false,
      signatureData: {},
      hoh: {},
    }
  },

  mounted() {
    if (this.application) {
      this.initData();
    }
  },

  watch: {
  },

  computed: {
    user() {
      return this.$store.getters['App/user']
    },

    ...mapState('Application', {
      application: 'application',
      applicant: 'applicant',
      signatures: 'signatures',
    }),
    ...mapGetters('Application', ['programSettings', 'student']),
  },

  methods: {
    addNewContact() {
      this.additionalContacts.push({
        first_name: '',
        last_name: '',
        email: '',
        phone1: '',
        phone1_enabled: true,
        phone2: '',
        phone2_enabled: true,
      })
    },

    deleteContact(index) {
      this.additionalContacts.splice(index, 1)
    },

    initData() {
      const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `app-jobs-emergency`)
      if (signatureFiltered) {
        this.$set(this.signatureData, this.applicant.id, { signed_at: signatureFiltered.created_at, completed: true });
      }

      if (this.application) {
        _.each(this.application.emegency_contacts, item => {
          this.additionalContacts.push({
            id: item?.id,
            first_name: item.first_name,
            last_name: item.last_name,
            email: item.email?.email_address,
            phone1: item.phone?.number,
            phone1_enabled: item.phone?.sms_enabled,
            phone2: item.secondary_phone?.number,
            phone2_enabled: item.secondary_phone?.sms_enabled,
          })
        })

        this.hoh = _.first(this.application.household.members);
      }
    },

    onSignatureUpdated($event) {
      if (!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null });
    },

    scrollTop: function () {
      if (window.pageYOffset > 0) {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset === 0) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 5)
      }
    },

    submit() {

    },

    async validateStep() {
      this.errors = {}
      let stepValid = true;

      if (this.application.jobs_data && this.application.jobs_data.medical_epi === null)
        this.errors['medical_epi'] = { errors: [this.__('validation.must_select_option')] };

      if (this.application.jobs_data && this.application.jobs_data.has_allergy === null)
        this.errors['has_allergy'] = { errors: [this.__('validation.must_select_option')] };

      if (this.application.jobs_data && this.application.jobs_data.medical_condition === null)
        this.errors['medical_condition'] = { errors: [this.__('validation.must_select_option')] };

      if (this.application.jobs_data && this.application.jobs_data.on_medication === null)
        this.errors['on_medication'] = { errors: [this.__('validation.must_select_option')] };

      if (!this.signatureData[this.applicant.id]) {
        this.errors['signature_' + this.applicant.id] = {
          errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
        };
      } else if (this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
        this.errors['signature_' + this.applicant.id] = {
          errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
        };
      }

      await this.$refs.emergencyForm.validate().then(async (isValid) => {
        stepValid = isValid;
      })

      if (_.size(this.errors) > 0) {
        stepValid = false
      }

      if (stepValid) {
        stepValid = await this.submitForm()
      }

      if (!stepValid) {
        setTimeout(() => {
          this.scrollTop()
        }, 10);
      }

      return stepValid
    },

    async submitForm() {
      let stepValid = false
      this.$emit('loading', true)
      let data = {
        application: this.application,
        signatures: this.signatureData,
        contacts: this.additionalContacts,
      }
      await axios.put(`/api/hope/jobs/applications/${this.application.id}/step-emergency`, data)
        .then((res) => {
          this.$emit('done', res)
          this.$emit('loading', false)
          stepValid = true
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.emergencyForm.setErrors(err.response.data.errors)
          }
          this.$emit('loading', false)
          stepValid = false
        })

      return stepValid
    },
  }
}
</script>

<style lang="scss">
.emergency-step-wrapper {
  .uk-card-primary {
    color: white;
    background-color: #0f7ae5;
    padding: 40px;
    font-size: 1.2em;
    border-radius: 6px;
  }

  .contact-legend {
    justify-content: space-between;
  }
}
</style>
